import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconV2IncorrectOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32"><path d="M26.755 28.168 16.004 17.416 16 17.42 5.25 28.17l-1.42-1.42 10.753-10.753L3.832 5.245 5.246 3.83l10.752 10.751.003-.003L26.67 3.91v2.84L17.42 16l-.003.003 10.751 10.752z" /></svg>
);
